export const CONDITION_TYPE = [
  {
    label: "勤務開始時間",
    value: "start_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務終了時間",
    value: "end_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "1日の作業時間",
    value: "active_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "1日の作業なし時間",
    value: "not_active_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "1日の合計Biz",
    value: "biz_point",
    step: 1000,
    limit: null,
    unit: "biz",
    type: "daily",
  },
  {
    label: "1日の一時間あたりのBiz",
    value: "biz_point_hour",
    step: 1000,
    limit: null,
    unit: "biz",
    type: "daily",
  },
  {
    label: "1日の分類別使用時間",
    value: "category_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "1日の分類別Biz",
    value: "category_biz_point",
    step: 1000,
    limit: null,
    unit: "biz",
    type: "daily",
  },
  {
    label: "1日のアプリ別使用時間",
    value: "application_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "1日のアプリ別Biz",
    value: "application_biz_point",
    step: 1000,
    limit: null,
    unit: "biz",
    type: "daily",
  },
  {
    label: "1日の勤務時間",
    value: "daily_work_time",
    step: 1,
    limit: 24,
    unit: "時間",
    type: "daily",
  },
  {
    label: "1週間の勤務時間",
    value: "weekly_work_time",
    step: 1,
    limit: 168,
    unit: "時間",
    type: "weekly",
  },
  {
    label: "1ヶ月間の勤務時間",
    value: "monthly_work_time",
    step: 10,
    limit: 744,
    unit: "時間",
    type: "monthly",
  },
  {
    label: "1日の残業時間",
    value: "daily_over_time",
    step: 1,
    limit: 24,
    unit: "時間",
    type: "daily",
  },
  {
    label: "1週間の残業時間",
    value: "weekly_over_time",
    step: 1,
    limit: 168,
    unit: "時間",
    type: "weekly",
  },
  {
    label: "1ヶ月間の残業時間",
    value: "monthly_over_time",
    step: 1,
    limit: 744,
    unit: "時間",
    type: "monthly",
  },
  {
    label: "休日の勤務時間",
    value: "holiday_work_time",
    step: 1,
    limit: 24,
    unit: "時間",
    type: "daily",
  },
  {
    label: "休日の作業時間",
    value: "holiday_active_time",
    step: 1,
    limit: 24,
    unit: "時間",
    type: "daily",
  },
  {
    label: "業務仕分け率",
    value: "labeling_rate",
    step: 10,
    limit: 100,
    unit: "%",
    type: "daily",
  },
]

export const ATTENDANCE_CONDITION_TYPE = [
  {
    label: "勤務予定開始時間との差",
    value: "attendance_schedule_start_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務予定終了時間との差",
    value: "attendance_schedule_end_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務予定時間との差",
    value: "attendance_schedule_work_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務予定時間",
    value: "attendance_schedule",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務実績開始時間との差",
    value: "attendance_record_start_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務実績終了時間との差",
    value: "attendance_record_end_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務実績時間との差",
    value: "attendance_record_work_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務実績時間",
    value: "attendance_record",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
]

export const OPERATOR_TYPE = [
  {
    label_1: "以前",
    label_2: "以下",
    value: "less_than_or_equal",
  },
  {
    label_1: "以降",
    label_2: "以上",
    value: "more_than_or_equal",
  },
]

export const TIMING_TYPE = [
  {
    label: "翌日",
    value: "next_day",
  },
  {
    label: "翌週",
    value: "next_week",
  },
  {
    label: "翌月",
    value: "next_month",
  },
]

export const CATEGORY_NAME = [
  {
    id: 1,
    label: "文章",
    value: "document",
  },
  {
    id: 2,
    label: "コミュニケーション",
    value: "communication",
  },
  {
    id: 3,
    label: "クリエイティブ",
    value: "creative",
  },
  {
    id: 4,
    label: "インターネット",
    value: "internet",
  },
  {
    id: 5,
    label: "経理",
    value: "accounting",
  },
  {
    id: 6,
    label: "営業・マーケティング",
    value: "marketing",
  },
  {
    id: 7,
    label: "その他",
    value: "other",
  },
]
